import { Component } from '@theme/component';

class ReadMoreSection extends Component {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.button = this.querySelector('.read-more-button');
    this.hiddenParagraphs = this.querySelectorAll('.read-more-hidden');
    
    if (!this.button || !this.hiddenParagraphs.length) return;

    this.button.addEventListener('click', () => {
      const isExpanded = this.button.textContent === 'Read less';
      $(this.hiddenParagraphs).slideToggle();
      this.button.textContent = isExpanded ? 'Read more' : 'Read less';
    });
  }
}

if (!customElements.get('read-more-section')) {
  customElements.define('read-more-section', ReadMoreSection);
}